import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Input,
  Dropdown
} from 'semantic-ui-react'

const SubAddressUX = (props: any) => {
    return(
      <div
        id="SubAddress"
        style={{height: "100%", padding: "15px 5px 15px 15px"}}>
        <Form
          className={props.disabled  ? "--override-disabled" : ""}
          id="SubAddressUX-Form-57">
          <FormGroup
            id="SubAddressUX-FormGroup-58"
            inline={true}>
            <FormField
              id="SubAddressUX-FormField-63"
              inline={true}
              width={6}>
              <label
                id="SubAddressUX-label-79"
                style={{fontWeight: "normal", minWidth: "95px", maxWidth: "95px"}}>
                {props.languageUX === "en" ? "House number / Current address" : "บ้านเลขที่ / Current address"}
              </label>
              <Input
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Input-${props.idPrefix}-No`}
                onChange={props.changeAddress("no")}
                style={{width: "100%"}}
                value={props.no}>
              </Input>
            </FormField>
            <FormField
              id="SubAddressUX-FormField-64"
              inline={true}
              width={6}>
              <label
                id="SubAddressUX-label-80"
                style={{fontWeight: "normal", minWidth: "115px", maxWidth: "115px"}}>
                {props.languageUX === "en" ? "Village name / Building name" : "ชื่อหมู่บ้าน/อาคาร / Village name"}
              </label>
              <Input
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Input-${props.idPrefix}-Name`}
                onChange={props.changeAddress("name")}
                style={{width: "100%"}}
                value={props.name}>
              </Input>
            </FormField>
            <FormField
              id="SubAddressUX-FormField-65"
              inline={true}
              style={{padding:0}}
              width={6}>
              <label
                id="SubAddressUX-label-81"
                style={{fontWeight: "normal", minWidth: "100px", maxWidth: "100px"}}>
                {props.languageUX === "en" ? "Residence type / Village type" : "ประเภทที่พักอาศัย / Village type"}
              </label>
              <Dropdown
                clearable={true}
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Dropdown-${props.idPrefix}-Type`}
                onChange={props.changeAddress("type")}
                options={props.homeTypeOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.type}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="SubAddressUX-FormGroup-59"
            inline={true}>
            <FormField
              id="SubAddressUX-FormField-66"
              inline={true}
              width={6}>
              <label
                id="SubAddressUX-label-85"
                style={{fontWeight: "normal", minWidth: "95px", maxWidth: "95px"}}>
                {props.languageUX === "en" ? "Village number" : "หมู่ที่ / Village number"}
              </label>
              <Input
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Input-${props.idPrefix}-Town`}
                onChange={props.changeAddress("town")}
                style={{width: "100%"}}
                value={props.town}>
              </Input>
            </FormField>
            <FormField
              id="SubAddressUX-FormField-67"
              inline={true}
              width={6}>
              <label
                id="SubAddressUX-label-86"
                style={{fontWeight: "normal", minWidth: "115px", maxWidth: "115px"}}>
                {props.languageUX === "en" ? "Soi / Soi" : "ซอย / Soi"}
              </label>
              <Input
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Input-${props.idPrefix}-Street`}
                onChange={props.changeAddress("street")}
                style={{width: "100%"}}
                value={props.street}>
              </Input>
            </FormField>
            <FormField
              id="SubAddressUX-FormField-68"
              inline={true}
              style={{padding:0}}
              width={6}>
              <label
                id="SubAddressUX-label-87"
                style={{fontWeight: "normal", minWidth: "100px", maxWidth: "100px"}}>
                {props.languageUX === "en" ? "Street" : "ถนน / Street"}
              </label>
              <Input
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Input-${props.idPrefix}-Road`}
                onChange={props.changeAddress("road")}
                style={{width: "100%"}}
                value={props.road}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="SubAddressUX-FormGroup-60"
            inline={true}>
            <FormField
              id="SubAddressUX-FormField-69"
              inline={true}
              width={4}>
              <label
                id="SubAddressUX-label-91"
                style={{fontWeight: "normal", minWidth: "95px", maxWidth: "95px"}}>
                {props.languageUX === "en" ? "Province / Province" : "จังหวัด / Province"}
              </label>
              <Dropdown
                clearable={true}
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Dropdown-${props.idPrefix}-Province`}
                onChange={props.changeAddress("province")}
                options={props.provinceOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.province}>
              </Dropdown>
            </FormField>
            <FormField
              id="SubAddressUX-FormField-70"
              inline={true}
              width={4}>
              <label
                id="SubAddressUX-label-92"
                style={{fontWeight: "normal"}}>
                {props.languageUX === "en" ? "District" : "อำเภอ / District"}
              </label>
              <Dropdown
                clearable={true}
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Dropdown-${props.idPrefix}-District`}
                onChange={props.changeAddress("district")}
                options={props.districtOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.district}>
              </Dropdown>
            </FormField>
            <FormField
              id="SubAddressUX-FormField-71"
              inline={true}
              width={4}>
              <label
                id="SubAddressUX-label-93"
                style={{fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Sub-district" : "ตำบล / Sub-district"}
              </label>
              <Dropdown
                clearable={true}
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Dropdown-${props.idPrefix}-City`}
                onChange={props.changeAddress("city")}
                options={props.cityOptions}
                search={true}
                selection={true}
                style={{width:"100%"}}
                value={props.city}>
              </Dropdown>
            </FormField>
            <FormField
              id="SubAddressUX-FormField-72"
              inline={true}
              style={{padding:0}}
              width={4}>
              <label
                id="SubAddressUX-label-94"
                style={{fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Postal code / Zip code" : "รหัสไปรษณีย์ / Zip code"}
              </label>
              <Input
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Input-${props.idPrefix}-Zipcode`}
                onChange={props.changeAddress("zipcode")}
                style={{width: "100%"}}
                value={props.zipcode}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="SubAddressUX-FormGroup-61"
            inline={true}>
            <FormField
              id="SubAddressUX-FormField-73"
              inline={true}
              width={6}>
              <label
                id="SubAddressUX-label-99"
                style={{fontWeight: "normal", minWidth: "95px", maxWidth: "95px"}}>
                {props.languageUX === "en" ? "Landline" : "โทรศัพท์บ้าน / Landline"}
              </label>
              <Input
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Input-${props.idPrefix}-TelHome`}
                onChange={props.changeAddress("tel_home")}
                style={{width: "100%"}}
                value={props.tel_home}>
              </Input>
              <Input
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Input-${props.idPrefix}-TelHome-Suffix`}
                onChange={props.changeAddress("tel_home_suffix")}
                style={{width: "12rem"}}
                value={props.tel_home_suffix}>
              </Input>
            </FormField>
            <FormField
              id="SubAddressUX-FormField-74"
              inline={true}
              width={6}>
              <label
                id="SubAddressUX-label-100"
                style={{fontWeight: "normal", minWidth: "115px", maxWidth: "115px"}}>
                {props.languageUX === "en" ? "Work phone" : "โทรศัพท์ที่ทำงาน"}
              </label>
              <Input
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Input-${props.idPrefix}-TelOffice`}
                onChange={props.changeAddress("tel_office")}
                style={{width: "100%"}}
                value={props.tel_office}>
              </Input>
              <Input
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Input-${props.idPrefix}-TelOffice-Suffix`}
                onChange={props.changeAddress("tel_office_suffix")}
                style={{width: "12rem"}}
                value={props.tel_office_suffix}>
              </Input>
            </FormField>
            <FormField
              id="SubAddressUX-FormField-75"
              inline={true}
              style={{padding:0}}
              width={6}>
              <label
                id="SubAddressUX-label-101"
                style={{fontWeight: "normal", minWidth: "100px", maxWidth: "100px"}}>
                {props.languageUX === "en" ? "Mobile phone / Mobile phone" : "โทรศัพท์มือถือ / Mobile phone"}
              </label>
              <Input
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Input-${props.idPrefix}-TelMobile`}
                onChange={props.changeAddress("tel_mobile")}
                style={{width: "100%"}}
                value={props.tel_mobile}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="SubAddressUX-FormGroup-62"
            inline={true}
            style={{margin:0}}>
            <FormField
              id="SubAddressUX-FormField-76"
              inline={true}
              width={6}>
              <label
                id="SubAddressUX-label-102"
                style={{fontWeight: "normal", minWidth: "95px", maxWidth: "95px"}}>
                {props.languageUX === "en" ? "E-mail" : "อีเมล"}
              </label>
              <Input
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Input-${props.idPrefix}-Email`}
                onChange={props.changeAddress("email")}
                style={{width: "100%"}}
                value={props.email}>
              </Input>
            </FormField>
            <FormField
              id="SubAddressUX-FormField-77"
              inline={true}
              width={6}>
              <label
                id="SubAddressUX-label-103"
                style={{fontWeight: "normal", minWidth: "115px", maxWidth: "115px"}}>
                {props.languageUX === "en" ? "Information Channel" : "ช่องทางการส่งข้อมูล / Information Channel"}
              </label>
              <Dropdown
                clearable={true}
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Dropdown-${props.idPrefix}-Channel`}
                onChange={props.changeAddress("channel")}
                options={props.contactOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.channel || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="SubAddressUX-FormField-78"
              inline={true}
              style={{padding:0}}
              width={6}>
              <label
                id="SubAddressUX-label-104"
                style={{fontWeight: "normal", minWidth: "100px", maxWidth: "100px"}}>
                {props.languageUX === "en" ? "Note / Note" : "หมายเหตุ  / Note"}
              </label>
              <Input
                disabled={props.disabled || false}
                fluid={true}
                id={`SubAddress-Input-${props.idPrefix}-Note`}
                onChange={props.changeAddress("note")}
                style={{width: "100%"}}
                value={props.note}>
              </Input>
            </FormField>
          </FormGroup>
        </Form>
      </div>
    )
}


export default SubAddressUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:52 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddress"
        },
        "style": {
          "type": "code",
          "value": "{height: \"100%\", padding: \"15px 5px 15px 15px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "code",
          "value": "props.disabled  ? \"--override-disabled\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-Form-57"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormGroup",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormGroup-58"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormGroup",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormGroup-59"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormGroup",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormGroup-60"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "FormGroup",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormGroup-61"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "FormGroup",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormGroup-62"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-63"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-64"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-65"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-66"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-67"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-68"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "FormField",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-69"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "FormField",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-70"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "FormField",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-71"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "FormField",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-72"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "FormField",
      "parent": 61,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-73"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "FormField",
      "parent": 61,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-74"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "FormField",
      "parent": 61,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-75"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 76,
      "name": "FormField",
      "parent": 62,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-76"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "FormField",
      "parent": 62,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-77"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "FormField",
      "parent": 62,
      "props": {
        "id": {
          "type": "value",
          "value": "SubAddressUX-FormField-78"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "label",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": "บ้านเลขที่ / Current address",
          "valueEN": "House number / Current address"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-79"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"95px\", maxWidth: \"95px\"}"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "label",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อหมู่บ้าน/อาคาร / Village name",
          "valueEN": "Village name / Building name"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-80"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"115px\", maxWidth: \"115px\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทที่พักอาศัย / Village type",
          "valueEN": "Residence type / Village type"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-81"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"100px\", maxWidth: \"100px\"}"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "Input",
      "parent": 63,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Input-${props.idPrefix}-No`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"no\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.no"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "Input",
      "parent": 64,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Input-${props.idPrefix}-Name`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"name\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.name"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Dropdown",
      "parent": 65,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Dropdown-${props.idPrefix}-Type`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"type\")"
        },
        "options": {
          "type": "code",
          "value": "props.homeTypeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.type"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "label",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "หมู่ที่ / Village number",
          "valueEN": "Village number"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-85"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"95px\", maxWidth: \"95px\"}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "label",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "ซอย / Soi",
          "valueEN": "Soi / Soi"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-86"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"115px\", maxWidth: \"115px\"}"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "label",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": "ถนน / Street",
          "valueEN": "Street"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-87"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"100px\", maxWidth: \"100px\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "Input",
      "parent": 66,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Input-${props.idPrefix}-Town`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"town\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.town"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "Input",
      "parent": 67,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Input-${props.idPrefix}-Street`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"street\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.street"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "Input",
      "parent": 68,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Input-${props.idPrefix}-Road`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"road\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.road"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "label",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "จังหวัด / Province",
          "valueEN": "Province / Province"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-91"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"95px\", maxWidth: \"95px\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "label",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": "อำเภอ / District",
          "valueEN": "District"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-92"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "label",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": "ตำบล / Sub-district",
          "valueEN": "Sub-district"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-93"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "label",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสไปรษณีย์ / Zip code",
          "valueEN": "Postal code / Zip code"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-94"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "Dropdown",
      "parent": 69,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Dropdown-${props.idPrefix}-Province`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"province\")"
        },
        "options": {
          "type": "code",
          "value": "props.provinceOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.province"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "Dropdown",
      "parent": 70,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Dropdown-${props.idPrefix}-District`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"district\")"
        },
        "options": {
          "type": "code",
          "value": "props.districtOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.district"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "Input",
      "parent": 72,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Input-${props.idPrefix}-Zipcode`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"zipcode\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.zipcode"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "label",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": "โทรศัพท์บ้าน / Landline",
          "valueEN": "Landline"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-99"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"95px\", maxWidth: \"95px\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "label",
      "parent": 74,
      "props": {
        "children": {
          "type": "value",
          "value": "โทรศัพท์ที่ทำงาน",
          "valueEN": "Work phone"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-100"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"115px\", maxWidth: \"115px\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "label",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": "โทรศัพท์มือถือ / Mobile phone",
          "valueEN": "Mobile phone / Mobile phone"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-101"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"100px\", maxWidth: \"100px\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "label",
      "parent": 76,
      "props": {
        "children": {
          "type": "value",
          "value": "อีเมล",
          "valueEN": "E-mail"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-102"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"95px\", maxWidth: \"95px\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "label",
      "parent": 77,
      "props": {
        "children": {
          "type": "value",
          "value": "ช่องทางการส่งข้อมูล / Information Channel",
          "valueEN": "Information Channel"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-103"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"115px\", maxWidth: \"115px\"}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "label",
      "parent": 78,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ  / Note",
          "valueEN": "Note / Note"
        },
        "id": {
          "type": "value",
          "value": "SubAddressUX-label-104"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"100px\", maxWidth: \"100px\"}"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "Input",
      "parent": 76,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Input-${props.idPrefix}-Email`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"email\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.email"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "Input",
      "parent": 73,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Input-${props.idPrefix}-TelHome`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"tel_home\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.tel_home"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "Input",
      "parent": 73,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Input-${props.idPrefix}-TelHome-Suffix`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"tel_home_suffix\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"12rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.tel_home_suffix"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "Input",
      "parent": 74,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Input-${props.idPrefix}-TelOffice`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"tel_office\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.tel_office"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "Input",
      "parent": 74,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Input-${props.idPrefix}-TelOffice-Suffix`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"tel_office_suffix\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"12rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.tel_office_suffix"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Input",
      "parent": 75,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Input-${props.idPrefix}-TelMobile`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"tel_mobile\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.tel_mobile"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "Dropdown",
      "parent": 77,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Dropdown-${props.idPrefix}-Channel`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"channel\")"
        },
        "options": {
          "type": "code",
          "value": "props.contactOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.channel || \"\""
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "Input",
      "parent": 78,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Input-${props.idPrefix}-Note`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"note\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.note"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "Dropdown",
      "parent": 71,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabled || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "code",
          "value": "`SubAddress-Dropdown-${props.idPrefix}-City`"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeAddress(\"city\")"
        },
        "options": {
          "type": "code",
          "value": "props.cityOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.city"
        }
      },
      "seq": 116,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 40,
  "isMounted": false,
  "memo": false,
  "name": "SubAddressUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 65
}

*********************************************************************************** */
